// Apolo IDE — BrainStatus badge (Sprint v2 Epic B6 WS B6.2).
//
// Polls window.apolo.mcp.status() on mount and subscribes to
// onStatusChange for live updates. Renders a colored pill: green ready,
// yellow starting/unhealthy, red failed/idle, neutral when bridge
// missing (non-Electron context).

import { useEffect, useState } from 'react';
import { AlertCircle, Check, Loader2, WifiOff } from 'lucide-react';

const TONES = {
  ready:        { label: 'Pronto',     cls: 'text-apolo-success bg-apolo-success/10 border-apolo-success/30', Icon: Check },
  starting:     { label: 'Iniciando',  cls: 'text-apolo-warning bg-apolo-warning/10 border-apolo-warning/30', Icon: Loader2 },
  restarting:   { label: 'Reiniciando',cls: 'text-apolo-warning bg-apolo-warning/10 border-apolo-warning/30', Icon: Loader2 },
  unhealthy:    { label: 'Instável',   cls: 'text-apolo-warning bg-apolo-warning/10 border-apolo-warning/30', Icon: AlertCircle },
  failed:       { label: 'Falhou',     cls: 'text-apolo-error bg-apolo-error/10 border-apolo-error/30',       Icon: AlertCircle },
  idle:         { label: 'Inativo',    cls: 'text-apolo-textTertiary bg-apolo-surface2 border-apolo-borderSubtle', Icon: AlertCircle },
  unknown:      { label: 'Indisponível', cls: 'text-apolo-textTertiary bg-apolo-surface2 border-apolo-borderSubtle', Icon: WifiOff },
};

function pickTone(status, health) {
  if (status === 'ready' && health === 'unhealthy') return TONES.unhealthy;
  return TONES[status] || TONES.unknown;
}

export default function BrainStatus({ initialStatus = null }) {
  const [snapshot, setSnapshot] = useState(initialStatus || { status: 'unknown', health: 'unknown' });

  useEffect(() => {
    const bridge = window.apolo?.mcp;
    if (!bridge) return undefined;
    let cancelled = false;
    bridge.status('obsidian').then((s) => { if (!cancelled) setSnapshot(s); }).catch(() => {});
    const unsubscribe = bridge.onStatusChange?.((payload) => {
      if (cancelled) return;
      if (!payload || payload.serverId === 'obsidian' || !payload.serverId) {
        setSnapshot(payload);
      }
    });
    return () => {
      cancelled = true;
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  const tone = pickTone(snapshot?.status, snapshot?.health);
  const Icon = tone.Icon;
  return (
    <span
      role="status"
      aria-label={`MCP obsidian: ${tone.label}`}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] ${tone.cls}`}
      title={`obsidian — status: ${snapshot?.status || 'unknown'}, health: ${snapshot?.health || 'unknown'}, restarts: ${snapshot?.retryCount ?? 0}`}
    >
      <Icon size={10} aria-hidden="true" className={tone.Icon === Loader2 ? 'animate-spin' : ''} />
      <span>{tone.label}</span>
    </span>
  );
}
